// mutations
const INVENTORY_REPORTS_ALL = (state, inventoryReports) => {
  if (inventoryReports.code === 1) {
    state.inventoryReports = inventoryReports.data
    state.status = 'success'
  } else {
    alert(inventoryReports.message)
    state.status = 'error'
  }
}

const INVENTORY_REPORTS_FORM = (state, inventoryReports) => {
  if (inventoryReports.code === 1) {
    state.inventoryReports = inventoryReports.data
    state.status = 'success'
  } else {
    alert(inventoryReports.message)
    state.status = 'error'
  }
}

const INVENTORY_REPORTS_SHOW = (state, inventoryReports) => {
  if (inventoryReports.code === 1) {
    state.inventoryReports = inventoryReports.data
    state.status = 'success'
  } else {
    alert(inventoryReports.message)
    state.status = 'error'
  }
}

const INVENTORY_REPORTS_CREATE = (state, inventoryReports) => {
  if (inventoryReports.code === 1) {
    state.inventoryReports = inventoryReports.data
    state.status = 'success'
    alert(inventoryReports.message)
  } else {
    alert(inventoryReports.message)
    state.status = 'error'
  }
}

const INVENTORY_REPORTS_UPDATE = (state, inventoryReports) => {
  if (inventoryReports.code === 1) {
    state.inventoryReports = inventoryReports.data
    state.status = 'success'
    alert(inventoryReports.message)
  } else {
    alert(inventoryReports.message)
    state.status = 'error'
  }
}

const INVENTORY_REPORTS_DELETE = (state, inventoryReports) => {
  if (inventoryReports.code === 1) {
    state.inventoryReports = inventoryReports.data
    state.status = 'success'
    alert(inventoryReports.message)
  } else {
    alert(inventoryReports.message)
    state.status = 'error'
  }
}

export default {
  INVENTORY_REPORTS_ALL,
  INVENTORY_REPORTS_FORM,
  INVENTORY_REPORTS_SHOW,
  INVENTORY_REPORTS_CREATE,
  INVENTORY_REPORTS_UPDATE,
  INVENTORY_REPORTS_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory/reports/mutations.js